import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import NoNoificationData from '../../atoms/Icons/NoNotificationData';
import {
  patientAccessTheme,
  Typography,
} from '@HomaHealth/ui-component-library';

interface NoNotifiy {
  label: String;
}

const useStyles = makeStyles()({
  mainContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '10px',
  },
});

const NoNotify: React.FC<NoNotifiy> = ({ label }) => {
  const { classes } = useStyles();
  return (
    <Grid className={classes.mainContainer}>
      <NoNoificationData />
      <Typography
        fontSize="12px"
        textColor={patientAccessTheme.palette.text.lowemphasis}
      >
        {label}
      </Typography>
    </Grid>
  );
};

export default NoNotify;
